import { useState } from 'react';
import { ArrowRight, ChevronDown, ChevronRight, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { img, productGroups } from '../data/siteData';

const selectionGuideLinks = [
  { label: 'Baler Selection Guide', to: '/baler-selection-guide' },
  { label: 'Horizontal Automatic Tie Balers', to: '/horizontal-automatic-tie-balers' },
  { label: 'Horizontal Manual Tie Balers', to: '/horizontal-manual-tie-balers' },
  { label: 'Multi-Material Full Eject Balers', to: '/multi-material-full-eject-balers' },
  { label: 'Vertical & Down-Packing Balers', to: '/vertical-down-packing-balers' },
  { label: 'Questionnaire', to: '/contact/questionnaire' },
];

const serviceLinks = [
  { label: 'Baler Replacement Parts', to: '/baler-replacement-parts' },
  { label: 'Baling Wire', to: '/baling-wire' },
  { label: 'Baling Wire Quotation Request', to: '/contact/baling-wire' },
  { label: 'Service Department', to: '/service-department' },
  { label: 'Baler Refurbishing Services', to: '/baler-refurbishing-services' },
];

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const closeAll = () => {
    setOpenMenu(null);
    setMobileOpen(false);
  };

  return (
    <header className="site-header" onMouseLeave={() => setOpenMenu(null)}>
      <div className="topline" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <span>Industrial balers</span>
        <span>Manufactured in the USA</span>
        <a href="tel:8002253796">(800) 225-3796</a>
      </div>
      <div className="nav-wrap">
        <Link className="brand" to="/" onClick={closeAll}>
          <img src={img('logos/CM_BALING_NEW_LOGO.png')} alt="C+M Baling Systems" style={{ width: "108px" }} />
        </Link>
        <nav className={mobileOpen ? 'nav open' : 'nav'} aria-label="Primary navigation">
          <div className="nav-item">
            <Link
              className="nav-button"
              to="/products"
              onClick={closeAll}
              onMouseEnter={() => setOpenMenu('products')}
              aria-expanded={openMenu === 'products'}
            >
              Products <ChevronDown size={15} />
            </Link>
          </div>
          <Link className="mobile-products-link" to="/products" onClick={closeAll}>Products</Link>
          <div className="nav-item">
            <Link
              className="nav-button"
              to="/baler-selection-guide"
              onClick={closeAll}
              onMouseEnter={() => setOpenMenu('selection')}
              aria-expanded={openMenu === 'selection'}
            >
              Selection Guide <ChevronDown size={15} />
            </Link>
            {openMenu === 'selection' ? (
              <div className="nav-dropdown-panel" onMouseEnter={() => setOpenMenu('selection')}>
                <div className="simple-menu">
                  <span className="eyebrow">Selection Guide</span>
                  {selectionGuideLinks.map((item) => (
                    <Link key={item.to} to={item.to} onClick={closeAll}>
                      <span>{item.label}</span>
                      <ChevronRight size={16} />
                    </Link>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
          <Link className="mobile-products-link" to="/baler-selection-guide" onClick={closeAll}>Selection Guide</Link>
          <div className="nav-item">
            <Link
              className="nav-button"
              to="/service-department"
              onClick={closeAll}
              onMouseEnter={() => setOpenMenu('service')}
              aria-expanded={openMenu === 'service'}
            >
              Parts & Service <ChevronDown size={15} />
            </Link>
            {openMenu === 'service' ? (
              <div className="nav-dropdown-panel" onMouseEnter={() => setOpenMenu('service')}>
                <div className="simple-menu">
                  <span className="eyebrow">Parts & Service</span>
                  {serviceLinks.map((item) => (
                    <Link key={item.to} to={item.to} onClick={closeAll}>
                      <span>{item.label}</span>
                      <ChevronRight size={16} />
                    </Link>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
          <Link className="mobile-products-link" to="/service-department" onClick={closeAll}>Parts & Service</Link>
          <Link to="/refurbished" onClick={closeAll}>Refurbished</Link>
          <Link to="/about-us" onClick={closeAll}>About Us</Link>
          <Link className="nav-cta" to="/contact/general-inquiry" onClick={closeAll}>Contact Us <ArrowRight size={15} /></Link>
        </nav>
        <button className="menu" onClick={() => setMobileOpen((value) => !value)} aria-label="Toggle navigation">
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </div>
      {openMenu === 'products' ? (
        <div className="mega" onMouseEnter={() => setOpenMenu('products')}>
          <div className="product-menu">
            <div className="product-menu-head">
              <span className="eyebrow">Products</span>
              <Link to="/products" onClick={closeAll}>View all products <ArrowRight size={15} /></Link>
            </div>
            <div className="product-menu-grid">
              {productGroups.map((group) => (
                <div className="product-menu-group" key={group.key}>
                  <h3>{group.title}</h3>
                  {group.items.map(([slug, title]) => (
                    <Link key={slug} to={`/${slug}`} onClick={closeAll}>
                      <span>{title}</span>
                      <ChevronRight size={16} />
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}

export default Header;
